<template>
  <vue-tel-input
    :inputClasses="inputClasses"
    :enabledCountryCode="false"
    :dynamicPlaceholder="true"
    :inputOptions="{ showDialCode: true}"
    :ignoredCountries="ignoredCountries"
    :preferredCountries="preferredCountries"
    v-model="number"
  ></vue-tel-input>
</template>

<script>
import { VueTelInput } from "vue-tel-input";
export default {
  name: "tel-input",
  props: {
    value: {
      type: String,
      default: ""
    },
    inputClasses: {
      type: [String, Array, Object],
      default: ""
    },
    ignoredCountries: {
      type: Array
    },
    preferredCountries: {
      type: Array
    }
  },
  components: {
    VueTelInput
  },
  data() {
    return {
      number: this.value
    };
  },
  watch: {
    number: {
      handler() {
        this.$emit("input", this.number);
      }
    }
  }
};
</script>
